// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__ft4F3","unreadBadge":"styles_unreadBadge__3FOU3","modalContent":"styles_modalContent__srLoj","modal":"styles_modal__1mB_j"};